import React from 'react';
import { Alert, Box, Link, ThemeProvider, Typography, } from '@kareo/design-system';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
import useA2PRegistrationBannerStatus from './useA2PRegistrationBannerStatus';
var theme = getDesignSystemTheme();
export default function A2PRegistrationWarning() {
    var _a, _b;
    var status = useA2PRegistrationBannerStatus();
    if (!status)
        return null;
    var isUnregistered = status === 'NOT_REGISTERED';
    var isPendingOTP = status === 'PENDING_OTP';
    var needsSupport = status === 'CAMPAIGN_ERROR' || status === 'LOCKED';
    var action = isUnregistered
        ? 'Complete Registration'
        : isPendingOTP
            ? 'CONTINUE'
            : needsSupport
                ? 'CONTACT SUPPORT'
                : 'RESUBMIT';
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(Box, { my: 2 },
            React.createElement(Alert, { severity: isUnregistered || isPendingOTP ? 'warning' : 'error', variant: "filled" },
                React.createElement(Box, { display: "flex", flexWrap: "wrap", alignItems: "center", gridGap: (_a = theme.spacing) === null || _a === void 0 ? void 0 : _a.call(theme, 2) },
                    React.createElement(Box, { flexGrow: 1, flexBasis: (_b = theme.breakpoints) === null || _b === void 0 ? void 0 : _b.values.sm, minWidth: 0 },
                        React.createElement(Typography, { variant: "body1", component: "span" }, isUnregistered ? (React.createElement(React.Fragment, null,
                            React.createElement("strong", null, "Action required:"),
                            " Your practice hasn\u2019t registered for text message (SMS) compliance yet. Appointment reminder and patient texts will be turned off for your practice on April 1, 2027. Register by December 31, 2026 to keep reminders and confirmations going.")) : isPendingOTP ? (React.createElement(React.Fragment, null,
                            React.createElement("strong", null, "Attention:"),
                            " Further action is needed to proceed with processing your A2P Registration.")) : (React.createElement(React.Fragment, null,
                            React.createElement("strong", null, "SMS COMPLIANCE REJECTED"),
                            ": We were unable to verify your business information for SMS compliance.",
                            !needsSupport &&
                                ' Please check your details and try again.')))),
                    React.createElement(Box, { flexShrink: 0 },
                        React.createElement(Link, { href: "/v2/#/admin/practice-settings/a2p-registration", target: "_parent", color: "inherit" },
                            React.createElement(Typography, { variant: "h4", component: "span", noWrap: true }, action))))))));
}
